import { FormattedDate, FormattedMessage, FormattedNumber } from 'react-intl';
import { FractionDigitsFormattedNumber, PoolTooltip, PoolTypography } from '@synergy/components-next';
import { PoolMath } from '@synergy/utils';
import { ReactElement } from 'react';
import { Stack } from '@mui/material';

import { useArticleDetailContext } from '../article-detail';

export const ArticleDetailPriceContainerDetailMainPrice = (): ReactElement | null => {
    const { article } = useArticleDetailContext();
    const { mainPrice, specialPrice, currency, priceQuantity } = article;

    return (
        <Stack flexDirection="row" alignItems="baseline" columnGap={1} rowGap={0} flexWrap="wrap">
            {specialPrice ? (
                <>
                    <PoolTooltip
                        title={
                            <FormattedMessage
                                id="app.specialOffer.tooltip"
                                values={{
                                    date: (
                                        <FormattedDate
                                            value={specialPrice.endDate}
                                            year="numeric"
                                            month="short"
                                            day="2-digit"
                                        />
                                    ),
                                }}
                            />
                        }
                    >
                        <PoolTypography variant="h4" color="error.dark">
                            <FractionDigitsFormattedNumber
                                value={specialPrice.price * (priceQuantity ?? 1)}
                                currency={currency}
                            />
                        </PoolTypography>
                    </PoolTooltip>
                    <PoolTypography variant="body1" sx={{ textDecoration: 'line-through' }}>
                        <FractionDigitsFormattedNumber value={mainPrice * (priceQuantity ?? 1)} currency={currency} />
                    </PoolTypography>

                    <PoolTypography variant="body1" color="error.dark">
                        <FormattedNumber
                            value={-PoolMath.getPercentDifference(mainPrice, specialPrice.price)}
                            style="percent"
                        />
                    </PoolTypography>
                </>
            ) : (
                <PoolTypography variant="h4">
                    <FractionDigitsFormattedNumber value={mainPrice * (priceQuantity ?? 1)} currency={currency} />
                </PoolTypography>
            )}
        </Stack>
    );
};
